var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isBulletinMessage
    ? _c("section", { staticClass: "bulletin-section" }, [
        _c("div", { staticClass: "bulletin-container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "bulletin-message collapsed-message",
              domProps: { innerHTML: _vm._s(_vm.message) }
            },
            [_vm._v(_vm._s(_vm.message))]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "i",
              {
                staticClass: "material-icons expand-collapse-icon",
                attrs: {
                  "data-test-element": "bulletin-message-expand",
                  title: "Expand bulletin message"
                },
                on: { click: _vm.toggleMessage }
              },
              [_vm._v("keyboard_arrow_down")]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.isExpanded
          ? _c(
              "div",
              { staticClass: "bulletin-container bulletin-container-expand" },
              [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bulletin-message expanded-message",
                    domProps: { innerHTML: _vm._s(_vm.message) }
                  },
                  [_vm._v(_vm._s(_vm.message))]
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons expand-collapse-icon",
                      attrs: {
                        "data-test-element": "bulletin-message-collapse",
                        title: "Collapse bulletin message"
                      },
                      on: { click: _vm.toggleMessage }
                    },
                    [_vm._v("keyboard_arrow_up")]
                  )
                ])
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bulletin-notification-icon" }, [
      _c(
        "i",
        {
          staticClass: "material-icons notification-icon",
          attrs: { "data-test-element": "bulletin-message-notification" }
        },
        [_vm._v("notifications")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bulletin-notification-icon" }, [
      _c("i", { staticClass: "material-icons notification-icon" }, [
        _vm._v("notifications")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc73bd3e", { render: render, staticRenderFns: staticRenderFns })
  }
}